<script setup lang="ts">
import { ScreenshotSharePopupExpose } from "@/components/mobile/popup/ScreenshotSharePopup.vue";
import { Story } from "@/types/entity";
import DownloadIcon from "@/components/icon/DownloadIcon.vue";
import StorySharePopup from "@/components/mobile/story/story-chapter/StorySharePopup.vue";
// Props & Emit
const props = defineProps<{
  story: Story;
  show: boolean;
}>();

const emit = defineEmits<{
  (e: "update:show", value: boolean): void;
}>();
</script>
<template>
  <div @click="emit('update:show', true)">
    <slot>
      <button class="btn btn-ghost btn-xs rounded">
        <download-icon class="icon-sm" />
      </button>
    </slot>
  </div>
  <story-share-popup
    :show="show"
    @update:show="emit('update:show', $event)"
    :story="story"
  />
</template>
